import { useSyncExternalStore } from 'react';

import { PendingRedirect } from '@/helpers/redirectTo';

export const usePendingRedirect = (): string | null =>
  useSyncExternalStore(PendingRedirect.subscribe, PendingRedirect.peek, () => null);
